'use strict';

module.exports = function (darc) {
  darc.addOperation({
    name: 'first',
    args: [],
    description: '',
    inputs: 'T[]',
    outputs: 'T',
    singular: true,
    use: function use(cursor) {
      return cursor.$eq(0);
    }
  });
};
//# sourceMappingURL=data:application/json;charset=utf-8;base64,eyJ2ZXJzaW9uIjozLCJzb3VyY2VzIjpbIi4uLy4uL3NvdXJjZS9vcHMvZmlyc3QuanMiXSwibmFtZXMiOlsibW9kdWxlIiwiZXhwb3J0cyIsImRhcmMiLCJhZGRPcGVyYXRpb24iLCJuYW1lIiwiYXJncyIsImRlc2NyaXB0aW9uIiwiaW5wdXRzIiwib3V0cHV0cyIsInNpbmd1bGFyIiwidXNlIiwiY3Vyc29yIiwiJGVxIl0sIm1hcHBpbmdzIjoiQUFBQTs7QUFFQUEsT0FBT0MsT0FBUCxHQUFpQixVQUFVQyxJQUFWLEVBQWlCO0FBRWpDQSxPQUFLQyxZQUFMLENBQW1CO0FBRWxCQyxVQUFNLE9BRlk7QUFHbEJDLFVBQU0sRUFIWTtBQUlsQkMsaUJBQWEsRUFKSztBQUtsQkMsWUFBUSxLQUxVO0FBTWxCQyxhQUFTLEdBTlM7QUFPbEJDLGNBQVUsSUFQUTtBQVFsQkMsU0FBSyxhQUFVQyxNQUFWLEVBQW1CO0FBRXZCLGFBQU9BLE9BQU9DLEdBQVAsQ0FBWSxDQUFaLENBQVA7QUFFQTtBQVppQixHQUFuQjtBQWdCQSxDQWxCRCIsInNvdXJjZXNDb250ZW50IjpbIid1c2Ugc3RyaWN0JztcblxubW9kdWxlLmV4cG9ydHMgPSBmdW5jdGlvbiggZGFyYyApIHtcblxuXHRkYXJjLmFkZE9wZXJhdGlvbigge1xuXG5cdFx0bmFtZTogJ2ZpcnN0Jyxcblx0XHRhcmdzOiBbXSxcblx0XHRkZXNjcmlwdGlvbjogJycsXG5cdFx0aW5wdXRzOiAnVFtdJyxcblx0XHRvdXRwdXRzOiAnVCcsXG5cdFx0c2luZ3VsYXI6IHRydWUsXG5cdFx0dXNlOiBmdW5jdGlvbiggY3Vyc29yICkge1xuXG5cdFx0XHRyZXR1cm4gY3Vyc29yLiRlcSggMCApO1xuXG5cdFx0fVxuXG5cdH0gKTtcblxufTtcbiJdfQ==